import { useContext, useState } from 'react'
import { LogOut, Globe } from 'lucide-react'
import { AuthContext } from '../context/AuthContext'
import { LanguageContext } from '../context/LanguageContext'
import './UserProfile.css'

export default function UserProfile() {
  const { user, logout } = useContext(AuthContext)
  const { language, switchLanguage } = useContext(LanguageContext)
  const [showMenu, setShowMenu] = useState(false)

  if (!user) return null

  return (
    <div className="user-profile">
      {/* Botón de idioma */}
      <button
        className="lang-switcher"
        onClick={() => switchLanguage(language === 'en' ? 'es' : 'en')}
        title={language === 'en' ? 'Cambiar a Español' : 'Switch to English'}
      >
        <Globe width={18} height={18} />
        {language === 'en' ? 'EN' : 'ES'}
      </button>

      {/* Avatar */}
      <div className="profile-menu">
        <button 
          className="avatar-button"
          onClick={() => setShowMenu(!showMenu)}
        >
          <div className="avatar-circle">
            {user.initials || '👤'}
          </div>
          <span className="user-name">{user.name}</span>
        </button>

        {/* Menú desplegable */}
        {showMenu && (
          <div className="dropdown-menu">
            <div className="menu-header">
              <div className="menu-avatar">{user.initials}</div>
              <div className="menu-info">
                <p className="menu-name">{user.name}</p>
                <p className="menu-email">{user.email}</p>
              </div>
            </div>

            <div className="menu-divider"></div>

            <button 
              className="logout-button"
              onClick={() => {
                logout()
                setShowMenu(false)
              }}
            >
              <LogOut width={18} height={18} />
              Cerrar Sesión
            </button>
          </div>
        )}
      </div>
    </div>
  )
}
